import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";
import { InboundFreightSummary } from "app/data/freights/model";

export const useInboundFreightSummary = (groupBy?: string, originCity?: string) => {
  const userState = useSelector(userSelector);

  const { isFetching, isLoading, data, error } =
    useQuery<InboundFreightSummary[]>({
      queryKey: [QUERY_KEYS.INBOUND_FREIGHT_SUMMARY, groupBy, originCity],
      queryFn: async () => {
        const destinationTerminalNumber = userState.activeTerminal?.id;
        let params = {};
        if (groupBy) {
          params = { groupBy };
        }
        if (originCity) {
          params = { ...params, originCity };
        }

        const response = await apiQueryAdapter.query<InboundFreightSummary[]>(`linehaul-manifests/terminal/${destinationTerminalNumber}/summary`,
          "GET",
          { params }
        );

        return response.data;
      },
    })
  return { isFetching, isLoading, data, error };
}